import React from "react";
import "./ExportReport.style.scss";
const ExportReport = ({ label, onClickHandler }) => {
    return (
        <button type="excel-button" className="export-report-btn" onClick={onClickHandler}>{label}</button>
    );
};

export default React.memo(ExportReport);